import { CC_PERMISSIONS, FeatureFlagKeys, PERM_TYPES } from '@communication-center/data-objects';
import React, { PropsWithChildren, ReactElement, useContext } from 'react';
import { useFeatureFlag } from '../../components/AppPreloading/hooks/settings/useUserSettings';
import PermissionContext from './PermissionsContext';

export type PermissionRestriction = [CC_PERMISSIONS, PERM_TYPES] | [CC_PERMISSIONS];
type Props = {
    to?: string[];
    permissions?: PermissionRestriction | PermissionRestriction[];
    creatorsIds?: number[];
    emptyRenderer?: ReactElement;
};

const Restricted: React.FC<React.PropsWithChildren<PropsWithChildren<Props>>> = ({ to, permissions, creatorsIds, children, emptyRenderer }) => {
    const { isAllowedTo } = useContext(PermissionContext);
    const permissionsFF = useFeatureFlag(FeatureFlagKeys.Permissions);

    if (isAllowedTo({ creatorsIds, permissions: permissionsFF ? permissions : undefined, allowedRoles: permissionsFF ? undefined : to })) {
        return <>{children}</>;
    }

    if (emptyRenderer) return emptyRenderer;

    return null;
};

export default Restricted;
